import { render, staticRenderFns } from "./ProfileProjectsEditor.vue?vue&type=template&id=67381f4c&scoped=true"
import script from "./ProfileProjectsEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileProjectsEditor.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileProjectsEditor.vue?vue&type=style&index=0&id=67381f4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67381f4c",
  null
  
)

export default component.exports